import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import RegieComponent from '../../../components/Mouvement/Panel/RegieComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class RegiePanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.REGIE;
		this.icon = { name: 'credit card outline' };
	}

	getLibelle = () => 'Régie';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.identifiantRegie);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<RegieComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default RegiePanel;
